import { css } from "@emotion/css";
import { theme } from "@repo-sapiens/theme";

export const ActivityContainer = css`
  width: 100%;
  max-width: 688px;
  margin: auto;
`;

export const StatsContainer = css`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-top: 8px;
`;
export const StatCardStyle = css`
  width: 100%;
  height: 60px;
  border-radius: 8px;
  border: 1px solid ${theme.colors.border.primary};

  background: ${theme.colors.background.secondary};
  padding: 0px 16px;

  backdrop-filter: blur(1.5px);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
  overflow: hidden;
  cursor: pointer;
`;
export const StatCardGradient = css`
  position: absolute;
  left: -40px;
  top: 0px;
`;
export const StatSection = css`
  display: flex;
  flex-direction: column;
`;

export const ActivityList = css`
  margin-bottom: 24px;
`;

export const ActivityItemStyle = css`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0px;
  cursor: pointer;
  border-bottom: 1px solid ${theme.colors.border.primary};
`;

export const ActivityItemLeft = css`
  width: 80%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;
export const ActivityItemRight = css``;
export const EmailTextHightlight = css`
  color: ${theme.colors.text["highlight/3"]};
`;
export const MeetingTextHightlight = css`
  color: ${theme.colors.text["highlight/1"]};
`;
export const DraftTextHightlight = css`
  color: ${theme.colors.accent["pink/main"]};
`;
